import { inicioAdmin, podeAdmin, type ModuloAdmin } from '../shared/permissoes-admin';
import type { Admin } from './api/admin';
import {
  createRootRouteWithContext, createRoute, createRouter, lazyRouteComponent, redirect,
} from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { Layout } from './componentes/Layout';
import { LayoutAdmin } from './componentes/LayoutAdmin';
import { adminEuQuery } from './api/admin';
import { euQuery } from './api/cliente';
import type { FiltrosBusca } from './api/busca';

/*
 * Cada tela é um chunk próprio: quem abre a landing não baixa o painel da
 * equipe nem o pagamento. O roteador espera o chunk antes de trocar a tela,
 * então o AnunciadorDeRota sempre encontra o h1 novo.
 */
const Inicio = lazyRouteComponent(() => import('./telas/publico/Inicio'), 'Inicio');
const Buscar = lazyRouteComponent(() => import('./telas/publico/Buscar'), 'Buscar');
const PerfilPublico = lazyRouteComponent(() => import('./telas/publico/PerfilPublico'), 'PerfilPublico');
const Entrar = lazyRouteComponent(() => import('./telas/publico/Entrar'), 'Entrar');
const Cadastrar = lazyRouteComponent(() => import('./telas/publico/Cadastrar'), 'Cadastrar');
const EsqueciSenha = lazyRouteComponent(() => import('./telas/publico/EsqueciSenha'), 'EsqueciSenha');
const RedefinirSenha = lazyRouteComponent(() => import('./telas/publico/RedefinirSenha'), 'RedefinirSenha');
const ConfirmarEmail = lazyRouteComponent(() => import('./telas/publico/ConfirmarEmail'), 'ConfirmarEmail');
const Ajuda = lazyRouteComponent(() => import('./telas/publico/Ajuda'), 'Ajuda');
const SolicitacaoSuporte = lazyRouteComponent(() => import('./telas/cliente/SolicitacaoSuporte'), 'SolicitacaoSuporte');
const Novidades = lazyRouteComponent(() => import('./telas/publico/Novidades'), 'Novidades');
const Acessibilidade = lazyRouteComponent(() => import('./telas/publico/Acessibilidade'), 'Acessibilidade');
const Termos = lazyRouteComponent(() => import('./telas/publico/Termos'), 'Termos');
const Privacidade = lazyRouteComponent(() => import('./telas/publico/Privacidade'), 'Privacidade');
const Categoria = lazyRouteComponent(() => import('./telas/publico/Categoria'), 'Categoria');
const Preferencias = lazyRouteComponent(() => import('./telas/cliente/Preferencias'), 'Preferencias');
const PedirServico = lazyRouteComponent(() => import('./telas/cliente/PedirServico'), 'PedirServico');
const ChamadoDetalhe = lazyRouteComponent(() => import('./telas/cliente/ChamadoDetalhe'), 'ChamadoDetalhe');
const GestaoPro = lazyRouteComponent(() => import('./telas/pro/Gestao'), 'GestaoPro');
const FinanceiroPro = lazyRouteComponent(() => import('./telas/pro/Financeiro'), 'FinanceiroPro');
const EstoquePro = lazyRouteComponent(() => import('./telas/pro/Estoque'), 'EstoquePro');
const EstoqueMaterialPro = lazyRouteComponent(() => import('./telas/pro/Estoque'), 'EstoqueMaterialPro');
const PrecosPro = lazyRouteComponent(() => import('./telas/pro/Precos'), 'PrecosPro');
const ClientesPro = lazyRouteComponent(() => import('./telas/pro/Clientes'), 'ClientesPro');
const ClientePro = lazyRouteComponent(() => import('./telas/pro/Clientes'), 'ClientePro');
const PainelPro = lazyRouteComponent(() => import('./telas/pro/PainelPro'), 'PainelPro');
const Recibo = lazyRouteComponent(() => import('./telas/cliente/Recibo'), 'Recibo');
const Conversas = lazyRouteComponent(() => import('./telas/cliente/Conversas'), 'Conversas');
const MeusChamados = lazyRouteComponent(() => import('./telas/cliente/MeusChamados'), 'MeusChamados');
const MinhaCasa = lazyRouteComponent(() => import('./telas/cliente/MinhaCasa'), 'MinhaCasa');
const Avisos = lazyRouteComponent(() => import('./telas/cliente/Avisos'), 'Avisos');
const Enderecos = lazyRouteComponent(() => import('./telas/cliente/Enderecos'), 'Enderecos');
const FormasPagamento = lazyRouteComponent(() => import('./telas/cliente/FormasPagamento'), 'FormasPagamento');
const Seguranca = lazyRouteComponent(() => import('./telas/cliente/Seguranca'), 'Seguranca');
const Sugestoes = lazyRouteComponent(() => import('./telas/cliente/Sugestoes'), 'Sugestoes');
const MeusDados = lazyRouteComponent(() => import('./telas/cliente/MeusDados'), 'MeusDados');
const CadastroPro = lazyRouteComponent(() => import('./telas/pro/CadastroPro'), 'CadastroPro');
const Oportunidades = lazyRouteComponent(() => import('./telas/pro/Oportunidades'), 'Oportunidades');
const AgendaPro = lazyRouteComponent(() => import('./telas/pro/Agenda'), 'AgendaPro');
const NovoOrcamento = lazyRouteComponent(() => import('./telas/pro/NovoOrcamento'), 'NovoOrcamento');
const PlanoPro = lazyRouteComponent(() => import('./telas/pro/Plano'), 'PlanoPro');
const PagamentosPro = lazyRouteComponent(() => import('./telas/pro/Pagamentos'), 'PagamentosPro');
const AvaliacoesPro = lazyRouteComponent(() => import('./telas/pro/Avaliacoes'), 'AvaliacoesPro');
const AdminEntrar = lazyRouteComponent(() => import('./telas/admin/Entrar'), 'AdminEntrar');
const AdminVerificacoes = lazyRouteComponent(() => import('./telas/admin/Verificacoes'), 'AdminVerificacoes');
const AdminAlteracoes = lazyRouteComponent(() => import('./telas/admin/Alteracoes'), 'AdminAlteracoes');
const AdminVerificacaoDetalhe = lazyRouteComponent(() => import('./telas/admin/VerificacaoDetalhe'), 'AdminVerificacaoDetalhe');
const AdminConfiguracao = lazyRouteComponent(() => import('./telas/admin/Configuracao'), 'AdminConfiguracao');
const AdminMonetizacao = lazyRouteComponent(() => import('./telas/admin/Monetizacao'), 'AdminMonetizacao');
const AdminProfissionais = lazyRouteComponent(() => import('./telas/admin/Profissionais'), 'AdminProfissionais');
const AdminPessoas = lazyRouteComponent(() => import('./telas/admin/Pessoas'), 'AdminPessoas');
const AdminSuporte = lazyRouteComponent(() => import('./telas/admin/Suporte'), 'AdminSuporte');
const AdminSuporteAtendimento = lazyRouteComponent(() => import('./telas/admin/SuporteAtendimento'), 'AdminSuporteAtendimento');
const AdminUsuarios = lazyRouteComponent(() => import('./telas/admin/Usuarios'), 'AdminUsuarios');
const AdminConvite = lazyRouteComponent(() => import('./telas/admin/Convite'), 'AdminConvite');
const AdminAcesso = lazyRouteComponent(() => import('./telas/admin/Acesso'), 'AdminAcesso');
const AdminConta = lazyRouteComponent(() => import('./telas/admin/Conta'), 'AdminConta');
const AdminDisputas = lazyRouteComponent(() => import('./telas/admin/Disputas'), 'AdminDisputas');
const AdminPrazos = lazyRouteComponent(() => import('./telas/admin/Prazos'), 'AdminPrazos');
const AdminMetricas = lazyRouteComponent(() => import('./telas/admin/Metricas'), 'AdminMetricas');
const AdminSugestoes = lazyRouteComponent(() => import('./telas/admin/Sugestoes'), 'AdminSugestoes');
const AdminGarantias = lazyRouteComponent(() => import('./telas/admin/Garantias'), 'AdminGarantias');
const AdminDenuncias = lazyRouteComponent(() => import('./telas/admin/Denuncias'), 'AdminDenuncias');

interface ContextoRoteador {
  queryClient: QueryClient;
}

/**
 * A raiz NÃO tem layout próprio: são duas árvores com cascas diferentes, e o
 * painel da equipe não pode aparecer dentro do cabeçalho do marketplace.
 */
const raiz = createRootRouteWithContext<ContextoRoteador>()({});

// ── Marketplace ────────────────────────────────────────────────────────────
const site = createRoute({ getParentRoute: () => raiz, id: 'site', component: Layout });

const inicio = createRoute({ getParentRoute: () => site, path: '/', component: Inicio });

// ── Área logada ────────────────────────────────────────────────────────────
/**
 * `beforeLoad` resolve a sessão ANTES do primeiro render: sem isso a tela
 * pisca o conteúdo e o leitor de tela anuncia duas vezes.
 */
const protegida = createRoute({
  getParentRoute: () => site,
  id: 'protegida',
  beforeLoad: async ({ context, location }) => {
    const usuario = await context.queryClient.ensureQueryData(euQuery);
    // Guarda para onde a pessoa ia: quem abriu um link de pedido no WhatsApp
    // precisa cair no pedido depois de entrar, não no início.
    if (!usuario) throw redirect({ to: '/entrar', search: { voltar: location.href } });
    return { usuario };
  },
});

const buscar = createRoute({
  getParentRoute: () => site,
  path: '/buscar',
  component: Buscar,
  // Os filtros vivem na URL: a busca fica compartilhável e o botão voltar do
  // navegador desfaz um filtro, que é o que a pessoa espera.
  validateSearch: (s: Record<string, unknown>): FiltrosBusca => {
    const texto = (k: string) => (typeof s[k] === 'string' && s[k] ? String(s[k]) : undefined);
    const lista = (k: string): string[] | undefined => {
      const v = s[k];
      if (Array.isArray(v)) return v.map(String);
      if (typeof v === 'string' && v) return [v];
      return undefined;
    };
    const ordem = texto('ordem');
    return {
      q: texto('q')?.slice(0, 80),
      categoria: texto('categoria'),
      ibge: texto('ibge'),
      acessibilidade: lista('acessibilidade'),
      nota_min: s['nota_min'] ? Number(s['nota_min']) : undefined,
      aceita_pagamento_app: s['aceita_pagamento_app'] === true || s['aceita_pagamento_app'] === 'true'
        ? true : undefined,
      ordem: ordem === 'nota' || ordem === 'servicos' ? ordem : undefined,
      pagina: s['pagina'] ? Number(s['pagina']) : undefined,
    };
  },
});
const perfilPublico = createRoute({
  getParentRoute: () => site, path: '/p/$slug', component: PerfilPublico,
});
const entrar = createRoute({
  getParentRoute: () => site, path: '/entrar', component: Entrar,
  validateSearch: (s: Record<string, unknown>): { voltar?: string; google?: string } => ({
    voltar: typeof s['voltar'] === 'string' ? s['voltar'] : undefined,
    google: typeof s['google'] === 'string' ? s['google'] : undefined,
  }),
});
const cadastrar = createRoute({
  getParentRoute: () => site, path: '/cadastrar', component: Cadastrar,
  validateSearch: (s: Record<string, unknown>): { google?: string; intencao?: 'profissional' } => ({
    google: typeof s['google'] === 'string' ? s['google'] : undefined,
    intencao: s['intencao'] === 'profissional' ? 'profissional' : undefined,
  }),
});
const esqueciSenha = createRoute({
  getParentRoute: () => site, path: '/esqueci-senha', component: EsqueciSenha,
});
/**
 * O token vem por `?token=` e é validado como string opcional: sem token a
 * tela explica o que houve em vez de estourar na validação da busca.
 */
const redefinirSenha = createRoute({
  getParentRoute: () => site,
  path: '/redefinir-senha',
  component: RedefinirSenha,
  validateSearch: (s: Record<string, unknown>): { token?: string } => ({
    token: typeof s['token'] === 'string' && s['token'] ? String(s['token']) : undefined,
  }),
});
const confirmarEmailRota = createRoute({
  getParentRoute: () => site,
  path: '/confirmar-email',
  component: ConfirmarEmail,
  validateSearch: (s: Record<string, unknown>): { token?: string } => ({
    token: typeof s['token'] === 'string' && s['token'] ? String(s['token']) : undefined,
  }),
});
const ajuda = createRoute({ getParentRoute: () => site, path: '/ajuda', component: Ajuda });
const novidades = createRoute({ getParentRoute: () => site, path: '/novidades', component: Novidades });
const acessibilidade = createRoute({
  getParentRoute: () => site, path: '/acessibilidade', component: Acessibilidade,
});
const termos = createRoute({ getParentRoute: () => site, path: '/termos', component: Termos });
const privacidade = createRoute({ getParentRoute: () => site, path: '/privacidade', component: Privacidade });
/**
 * Página de um tipo de serviço. Pública: é o texto que ajuda quem ainda não
 * sabe o que pedir, e exigir conta para lê-lo inverteria a ordem das coisas.
 */
const categoria = createRoute({
  getParentRoute: () => site, path: '/servicos/$slug', component: Categoria,
});
/** O mesmo serviço numa cidade: é a página que o buscador acha ("eletricista em Itumbiara"). */
const categoriaCidade = createRoute({
  getParentRoute: () => site, path: '/servicos/$slug/$cidade', component: Categoria,
});

// Cada rota é declarada explicitamente, sem helper: um helper genérico apaga
// os tipos literais de caminho, e é justamente eles que fazem o roteador
// reprovar em build um <Link to="..."> para uma tela que não existe.
const conta = createRoute({
  getParentRoute: () => protegida, path: '/app/conta', component: Preferencias,
});
const contaA11y = createRoute({
  getParentRoute: () => protegida, path: '/app/conta/acessibilidade', component: Preferencias,
});
const pedir = createRoute({
  getParentRoute: () => protegida,
  path: '/app/pedir',
  component: PedirServico,
  // `?profissional=<slug>` chega do botão "Pedir orçamento" no perfil de
  // alguém. Fica na URL para o botão voltar do navegador não perder a escolha.
  // `?categoria=<slug>` vem do "Contratar de novo": já abre no mesmo serviço.
  validateSearch: (s: Record<string, unknown>): { profissional?: string; categoria?: string } => ({
    profissional: typeof s['profissional'] === 'string' && s['profissional']
      ? String(s['profissional'])
      : undefined,
    categoria: typeof s['categoria'] === 'string' && s['categoria']
      ? String(s['categoria'])
      : undefined,
  }),
});
const minhaCasa = createRoute({
  getParentRoute: () => protegida, path: '/app/casa', component: MinhaCasa,
});
const meusChamados = createRoute({
  getParentRoute: () => protegida, path: '/app/chamados', component: MeusChamados,
});
const chamadoDetalhe = createRoute({
  getParentRoute: () => protegida, path: '/app/chamados/$id', component: ChamadoDetalhe,
});
const conversas = createRoute({
  getParentRoute: () => protegida, path: '/app/conversas', component: Conversas,
});
const recibo = createRoute({
  getParentRoute: () => protegida, path: '/app/chamados/$id/recibo', component: Recibo,
});
const solicitacaoSuporte = createRoute({
  getParentRoute: () => protegida, path: '/ajuda/solicitacoes/$id', component: SolicitacaoSuporte,
});
const avisos = createRoute({
  getParentRoute: () => protegida, path: '/app/avisos', component: Avisos,
});

const enderecos = createRoute({
  getParentRoute: () => protegida, path: '/app/enderecos', component: Enderecos,
});
const formasPagamento = createRoute({
  getParentRoute: () => protegida, path: '/app/formas-pagamento', component: FormasPagamento,
});
/** Quadro de sugestões: cliente e profissional mandam ideias e apoiam as dos outros. */
const sugestoes = createRoute({
  getParentRoute: () => protegida, path: '/app/sugestoes', component: Sugestoes,
});
const seguranca = createRoute({
  getParentRoute: () => protegida, path: '/app/seguranca', component: Seguranca,
});
const meusDados = createRoute({
  getParentRoute: () => protegida, path: '/app/meus-dados', component: MeusDados,
});
const cadastroPro = createRoute({
  getParentRoute: () => protegida, path: '/pro/cadastro', component: CadastroPro,
});
const agendaPro = createRoute({
  getParentRoute: () => protegida, path: '/pro/agenda', component: AgendaPro,
});
const oportunidades = createRoute({
  getParentRoute: () => protegida, path: '/pro/oportunidades', component: Oportunidades,
});
const novoOrcamento = createRoute({
  getParentRoute: () => protegida, path: '/pro/orcamentos/novo/$chamadoId', component: NovoOrcamento,
});
const planoPro = createRoute({
  getParentRoute: () => protegida, path: '/pro/plano', component: PlanoPro,
});
/**
 * Destino do `return_url` do cadastro bancário hospedado. O `?ok=1` e o
 * `?refresh=1` que a Stripe devolve são aceitos e ignorados: quem diz se o
 * recebimento está liberado é o webhook, não o redirect.
 */
const avaliacoesPro = createRoute({
  getParentRoute: () => protegida, path: '/pro/avaliacoes', component: AvaliacoesPro,
});
const painelPro = createRoute({
  getParentRoute: () => protegida, path: '/pro/inicio', component: PainelPro,
});
const gestaoPro = createRoute({
  getParentRoute: () => protegida, path: '/pro/gestao', component: GestaoPro,
});
const financeiroPro = createRoute({
  getParentRoute: () => protegida, path: '/pro/financeiro', component: FinanceiroPro,
});
const estoquePro = createRoute({
  getParentRoute: () => protegida, path: '/pro/estoque', component: EstoquePro,
});
const estoqueMaterialPro = createRoute({
  getParentRoute: () => protegida, path: '/pro/estoque/$id', component: EstoqueMaterialPro,
});
const precosPro = createRoute({
  getParentRoute: () => protegida, path: '/pro/precos', component: PrecosPro,
});
const clientesPro = createRoute({
  getParentRoute: () => protegida, path: '/pro/clientes', component: ClientesPro,
});
const clientePro = createRoute({
  getParentRoute: () => protegida, path: '/pro/clientes/$chave', component: ClientePro,
});
const pagamentosPro = createRoute({
  getParentRoute: () => protegida,
  path: '/pro/pagamentos',
  component: PagamentosPro,
  validateSearch: (): Record<string, never> => ({}),
});

// ── Painel da equipe ───────────────────────────────────────────────────────
/**
 * Árvore separada, com layout próprio e guarda própria. A sessão de admin usa
 * outro cookie e outra tabela; aqui a separação continua também na navegação,
 * para que ninguém decida sobre o cadastro de alguém achando que está no app.
 */
const admin = createRoute({
  getParentRoute: () => raiz,
  id: 'admin',
  component: LayoutAdmin,
});

const adminEntrar = createRoute({
  getParentRoute: () => admin, path: '/admin/entrar', component: AdminEntrar,
});

/** Link do convite: público, quem prova a identidade é o token. */
const adminConvite = createRoute({
  getParentRoute: () => admin, path: '/admin/convite', component: AdminConvite,
  validateSearch: (s: Record<string, unknown>): { token?: string } => ({
    token: typeof s['token'] === 'string' && s['token'] ? String(s['token']) : undefined,
  }),
});

/**
 * Tela de módulo sem permissão vai para a primeira tela liberada. O servidor
 * recusa de qualquer jeito; isto só evita abrir uma tela que daria erro.
 */
function exigeModulo(modulo: ModuloAdmin) {
  return ({ context }: { context: { admin?: Admin } }) => {
    const a = context.admin;
    if (a && !podeAdmin(a, modulo)) throw redirect({ to: inicioAdmin(a) as never });
  };
}
const soDono = ({ context }: { context: { admin?: Admin } }) => {
  const a = context.admin;
  if (a && a.papel !== 'dono') throw redirect({ to: inicioAdmin(a) as never });
};

const adminProtegido = createRoute({
  getParentRoute: () => admin,
  id: 'adminProtegido',
  beforeLoad: async ({ context }) => {
    const eu = await context.queryClient.ensureQueryData(adminEuQuery);
    if (!eu) throw redirect({ to: '/admin/entrar' });
    return { admin: eu };
  },
});

const adminAlteracoes = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: exigeModulo('alteracoes'), path: '/admin/alteracoes',
  component: AdminAlteracoes,
});
const adminVerificacoes = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: exigeModulo('cadastros'), path: '/admin/verificacoes',
  component: AdminVerificacoes,
});
const adminVerificacaoDetalhe = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: exigeModulo('cadastros'), path: '/admin/verificacoes/$usuarioId',
  component: AdminVerificacaoDetalhe,
});
const adminDisputas = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: exigeModulo('disputas'), path: '/admin/disputas', component: AdminDisputas,
});
const adminGarantias = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: exigeModulo('garantias'), path: '/admin/garantias', component: AdminGarantias,
});
const adminPrazos = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: exigeModulo('prazos'), path: '/admin/prazos', component: AdminPrazos,
});
const adminSugestoes = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: exigeModulo('sugestoes'), path: '/admin/sugestoes', component: AdminSugestoes,
});
const adminMetricas = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: exigeModulo('metricas'), path: '/admin/metricas', component: AdminMetricas,
});
const adminDenuncias = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: exigeModulo('denuncias'), path: '/admin/denuncias', component: AdminDenuncias,
});
const adminSuporte = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: exigeModulo('suporte'), path: '/admin/suporte', component: AdminSuporte,
});
const adminSuporteAtendimento = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: exigeModulo('suporte'), path: '/admin/suporte/$id', component: AdminSuporteAtendimento,
});
const adminUsuarios = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: soDono, path: '/admin/usuarios', component: AdminUsuarios,
});
const adminAcesso = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: soDono, path: '/admin/acesso', component: AdminAcesso,
});
const adminConta = createRoute({
  getParentRoute: () => adminProtegido, path: '/admin/conta', component: AdminConta,
});

const adminConfiguracao = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: exigeModulo('integracoes'), path: '/admin/configuracao',
  component: AdminConfiguracao,
});

const adminMonetizacao = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: exigeModulo('monetizacao'), path: '/admin/monetizacao',
  component: AdminMonetizacao,
});

const adminPessoas = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: exigeModulo('pessoas'), path: '/admin/pessoas',
  component: AdminPessoas,
});
const adminProfissionais = createRoute({
  getParentRoute: () => adminProtegido, beforeLoad: exigeModulo('parceiros'), path: '/admin/profissionais',
  component: AdminProfissionais,
});

const arvore = raiz.addChildren([
  site.addChildren([
    inicio, entrar, cadastrar, esqueciSenha, redefinirSenha, confirmarEmailRota, ajuda, novidades,
    acessibilidade, termos, privacidade, categoria, categoriaCidade,
    // Vitrine aberta: buscar e ver perfil não pedem conta; pedir serviço pede.
    buscar, perfilPublico,
    protegida.addChildren([
      conta, contaA11y, pedir, meusChamados, minhaCasa, chamadoDetalhe, recibo, conversas, enderecos, formasPagamento, avisos, solicitacaoSuporte,
      seguranca, sugestoes, meusDados,
      painelPro, gestaoPro, financeiroPro, estoquePro, estoqueMaterialPro, precosPro, clientesPro, clientePro, cadastroPro, agendaPro, oportunidades, novoOrcamento, planoPro, pagamentosPro, avaliacoesPro,
    ]),
  ]),
  admin.addChildren([
    adminEntrar, adminConvite,
    adminProtegido.addChildren([
      adminVerificacoes, adminVerificacaoDetalhe, adminAlteracoes, adminConta,
      adminSuporte, adminSuporteAtendimento, adminUsuarios, adminAcesso,
      adminDisputas, adminPrazos, adminGarantias, adminDenuncias, adminSugestoes, adminMetricas,
      adminConfiguracao, adminMonetizacao, adminProfissionais, adminPessoas,
    ]),
  ]),
]);

export function criarRoteador(queryClient: QueryClient) {
  return createRouter({
    routeTree: arvore,
    context: { queryClient },
    defaultPreload: 'intent',
    // Troca de tela com View Transition onde o navegador suporta; o CSS
    // (estilo.css) zera a animação com movimento reduzido.
    defaultViewTransition: { types: ({ pathChanged }) => (pathChanged ? ['tela'] : false) },
    // O scroll e o foco são tratados pelo AnunciadorDeRota, que também anuncia
    // a troca de tela; deixar o roteador restaurar sozinho brigaria com ele.
    scrollRestoration: false,
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof criarRoteador>;
  }
}
